import { shallowRef } from 'vue';

import type { RepeatPaymentPrefill } from './repeat-payment.types';

const pendingRepeatPaymentPrefill = shallowRef<RepeatPaymentPrefill | null>(null);

export const useRepeatPaymentState = () => {
  const setPendingRepeatPaymentPrefill = (prefill: RepeatPaymentPrefill): void => {
    pendingRepeatPaymentPrefill.value = prefill;
  };

  const consumePendingRepeatPaymentPrefill = (): RepeatPaymentPrefill | null => {
    const prefill = pendingRepeatPaymentPrefill.value;
    pendingRepeatPaymentPrefill.value = null;

    return prefill;
  };

  const clearPendingRepeatPaymentPrefill = (): void => {
    pendingRepeatPaymentPrefill.value = null;
  };

  return {
    pendingRepeatPaymentPrefill,
    setPendingRepeatPaymentPrefill,
    consumePendingRepeatPaymentPrefill,
    clearPendingRepeatPaymentPrefill,
  };
};
